"use client";

import PropertyErrorPage from "@/ui/AppRouter/PropertyErrorPage";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <PropertyErrorPage
      error={error}
      reset={reset}
      propertyType="buy"
    />
  );
}
